import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarQuestion = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.984 9.664h16.041M15.64 3v2.962M8.37 3v2.962M10.375 21h-2.18C5.55 21 3.9 19.494 3.9 16.745V8.6c0-2.705 1.65-4.177 4.294-4.177h7.62c2.652 0 4.294 1.472 4.286 4.177v3.233M7.666 12.941h.01M7.666 16.418h.01M11.334 12.941h.01M15.902 21.067l.006.035"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.902 18.827c-.01-.818.734-1.164 1.288-1.48.674-.372 1.131-.965 1.131-1.786a2.19 2.19 0 0 0-2.194-2.194 2.187 2.187 0 0 0-2.194 2.194"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarQuestion);
export default ForwardRef;
